module.exports = __webpack_public_path__ + "iot_data/img/iniot.e507c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iniot.png
// module id = qYdl
// module chunks = 1